import { DynamicModalCopyList } from '@models/cms/cms-dynamic/dynamic-page.model';
import { PlusgradeRequest } from '@models/requests/plusgrade-request.model';
import { PlusgradeResponse } from '@models/responses/plusgrade-response.model';
import { createAction, props } from '@ngrx/store';

const enum PlusgradeActionTypes {
  getEligibility = '[plusgrade] GET_ELIGIBILITY',
  getEligibilitySuccess = '[plusgrade] GET_ELIGIBILITY_SUCCESS',
}

export const plusgradeGetEligibility = createAction(
  PlusgradeActionTypes.getEligibility,
  props<{ request: PlusgradeRequest; modals: DynamicModalCopyList }>(),
);

export const plusgradeGetEligibilitySuccess = createAction(
  PlusgradeActionTypes.getEligibilitySuccess,
  props<{ payload: PlusgradeResponse }>(),
);
